import { divide } from 'lodash-es'
import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'

import DatePicker from 'react-datepicker'
import UpdateContent from '../../Services/Mutations/UpdateContent'
import UpdateStickyPositionService from '../../Services/Mutations/UpdateStickyPositionService'

class ContentStickyActions extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			stickyPost: false,
			stickyModalVisible: false,
			isDataChanged: false,
			stickyPost: false,
			positionFromTop: '',
			stickyEndDateTime: new Date(new Date().setHours(new Date().getHours() + 12)),
			showSticky: 'Unlimited',
			stickyTargetImpressions: 10,
			isInAppMessage: false,
			pushRankUpTo: 30,
			pushRankTo: 1,
		}
	}
	handleModal = (visible) => {
		this.setState({ stickyModalVisible: visible })
	}

	closeStickyModal = () => {
		const stickyPost =
			this.props.item.stickyPost != undefined &&
			this.props.item.stickyPost != null &&
			this.props.item.stickyPost
		this.setState({
			stickyModalVisible: false,
			stickyPost: stickyPost,
			positionFromTop:
				this.props.item.tempPositionFromTop != undefined &&
					this.props.item.tempPositionFromTop != null
					? this.props.item.tempPositionFromTop
					: this.props.item.positionFromTop != undefined && this.props.item.positionFromTop != null
						? this.props.item.positionFromTop
						: '',
			stickyTargetImpressions: this.props.item.stickyTargetImpressions,
			pushRankUpTo: this.props.item.pushRankUpTo ? this.props.item.pushRankUpTo : 30,
			pushRankTo: this.props.item.pushRankTo ? this.props.item.pushRankTo : '1',
			showSticky: this.props.item.showSticky ? this.props.item.showSticky : 'Unlimited',
			stickyEndDateTime:
				this.props.item.stickyEndDateTime != undefined && this.props.item.stickyEndDateTime != null
					? parseInt(this.props.item.stickyEndDateTime) * 1000
					: this.state.stickyEndDateTime,
		})
	}

	handleChangeStickyPositionFromTop = (positionFromTop) => {
		this.setState({
			isDataChanged: true,
			positionFromTop,
		})
	}
	handleChangeShowStickyOption = (showSticky) => {
		this.setState({
			isDataChanged: true,

			showSticky,
		})
	}
	handleChangeStickyNoOfTimes = (stickyTargetImpressions) => {
		this.setState({
			isDataChanged: true,
			stickyTargetImpressions,
		})
	}
	handleChangeStickyEndDateTime = (stickyEndDateTime) => {
		this.setState({
			isDataChanged: true,

			stickyEndDateTime,
		})
	}
	handleChangePushRankUpTo = (pushRankUpTo) => {
		this.setState({
			isDataChanged: true,
			pushRankUpTo,
		})
	}
	handleChangePushRankTo = (pushRankTo) => {
		this.setState({
			isDataChanged: true,
			pushRankTo,
		})
	}
	toggleIsSticky = () => {
		this.setState({
			isDataChanged: true,
			stickyPost: !this.state.stickyPost,
			// positionFromTop: '',
			stickyEndDateTime: new Date(new Date().setHours(new Date().getHours() + 12)),
			// showSticky: 'Once',
			// stickyTargetImpressions: 10,
			isInAppMessage: false,
		})
	}
	stripTypenames = (value) => {
		if (Array.isArray(value)) {
			return value.map(this.stripTypenames)
		} else if (value !== null && typeof value === 'object') {
			const newObject = {}
			for (const property in value) {
				if (property !== '__typename') {
					newObject[property] = this.stripTypenames(value[property])
				}
			}
			return newObject
		} else {
			return value
		}
	}

	updateContentSticky = async () => {
		this.setState({ stickyModalVisible: false })
		const input = {}
		const inputObj = this.stripTypenames(this.props.item)
		input['PK'] = inputObj.PK
		input['SK'] = inputObj.SK
		if (this.state.stickyPost) {

			input['createInBoxOffice'] = false

			input['isInAppMessage'] = true
			input['stickyPost'] = this.state.stickyPost
			if (
				inputObj.stickyInProgressDateTime != undefined &&
				inputObj.stickyInProgressDateTime != null &&
				inputObj.stickyInProgressDateTime
			) {
				console.log('editing sticky post', inputObj.stickyInProgressDateTime)
				const stickyPublishedDateTime = inputObj.stickyInProgressDateTime
				const PresentDateTimeStamp = Math.round(new Date().getTime() / 1000)
				console.log('PresentDateTimeStampPresentDateTimeStamp', PresentDateTimeStamp)
				const stickyPushEndDateTime =
					parseInt(stickyPublishedDateTime) + parseInt(this.state.pushRankUpTo) * 60
				console.log('stickyPushEndDateTime', stickyPushEndDateTime)
				if (PresentDateTimeStamp - stickyPushEndDateTime > 0) {
					input['positionFromTop'] = this.state.positionFromTop
				} else {
					input['positionFromTop'] = this.state.pushRankTo
				}
			} else {
				input['positionFromTop'] =
					this.contentStatus != undefined &&
						this.contentStatus != null &&
						this.contentStatus == 'm#published' &&
						this.isPreviouslyStickyPost != undefined &&
						this.isPreviouslyStickyPost != null &&
						this.isPreviouslyStickyPost
						? parseInt(this.state.positionFromTop)
						: parseInt(this.state.pushRankTo)
			}

			input['tempPositionFromTop'] = parseInt(this.state.positionFromTop)
			input['showSticky'] = this.state.showSticky
			if (this.state.showSticky == 'stickyNoOfTimes') {
				input['stickyTargetImpressions'] = this.state.stickyTargetImpressions
			}
			const stickyEndDateTimeStamp = new Date(this.state.stickyEndDateTime).getTime()
			input['stickyEndDateTime'] = Math.floor(stickyEndDateTimeStamp / 1000)
			input['pushRankUpTo'] = parseInt(this.state.pushRankUpTo)
			input['pushRankTo'] = parseInt(this.state.pushRankTo)
			input['isPushRankActive'] = true
		} else {
			input['stickyPost'] = false
			input['isPushRankActive'] = false
			input['isInAppMessage'] = false
			input['createInBoxOffice'] = true
		}

		console.log(input, 'inputttt')
		const response = await UpdateStickyPositionService(input)
		console.log(response, 'response111111===========')
		if (response.statusCode == 'A358') {
			this.props.displayToast('success', 'Content Sticky Data Edited Successfully')
			setTimeout(() => {
				window.location.reload()
			}, 2000)
		} else {
			this.props.displayToast('error', 'Failed to update sticky data for content')
		}
	}

	componentDidMount = () => {
		const stickyPost =
			this.props.item.stickyPost != undefined &&
			this.props.item.stickyPost != null &&
			this.props.item.stickyPost
		this.setState({
			stickyPost: stickyPost,
			positionFromTop:
				this.props.item.tempPositionFromTop != undefined &&
					this.props.item.tempPositionFromTop != null
					? this.props.item.tempPositionFromTop
					: this.props.item.positionFromTop != undefined && this.props.item.positionFromTop != null
						? this.props.item.positionFromTop
						: '',
			stickyTargetImpressions: this.props.item.stickyTargetImpressions,
			pushRankUpTo: this.props.item.pushRankUpTo ? this.props.item.pushRankUpTo : 30,
			pushRankTo: this.props.item.pushRankTo ? this.props.item.pushRankTo : '1',
			showSticky: this.props.item.showSticky ? this.props.item.showSticky : 'Unlimited',
			stickyEndDateTime:
				this.props.item.stickyEndDateTime != undefined && this.props.item.stickyEndDateTime != null
					? parseInt(this.props.item.stickyEndDateTime) * 1000
					: this.state.stickyEndDateTime,
		})
	}
	render() {
		const { stickyModalVisible } = this.state
		return (
			<div>
				{this.props.rank ? (
					<div
						onClick={() => {
							this.handleModal(true)
						}}
					>
						<label> Sticky</label>
					</div>
				) : (
					<div
						class='col-md-2'
						onClick={() => {
							this.handleModal(true)
						}}
					>
						<i class='fas fa-star' />
					</div>
				)}

				<Modal show={stickyModalVisible} onHide={() => this.closeStickyModal()}>
					<Modal.Body>
						<div>
							<div className='custom-control custom-switch'>
								<input
									type='checkbox'
									className='custom-control-input'
									onChange={() => this.toggleIsSticky()}
									checked={this.state.stickyPost}
									id='stickyPost'
									readOnly
								/>
								<label className='custom-control-label' htmlFor='stickyPost'>
									Is Sticky
								</label>
							</div>
							{this.state.stickyPost ? (
								<div>
									<div class='row mb-2'>
										<label for='text'>Sticky End Date And Time</label>
										<DatePicker
											dateFormat={'dd/MM/yyyy HH:mm '}
											minDate={new Date()}
											selected={this.state.stickyEndDateTime}
											showTimeSelect
											onChange={(date) => this.handleChangeStickyEndDateTime(date)}
										/>
									</div>
									<div class='row mb-2'>
										<label for='text'>Position From Top </label>
										<input
											id='positionFromTop'
											type='text'
											onKeyPress={(event) => {
												if (!/[0-9]/.test(event.key)) {
													event.preventDefault()
												}
											}}
											onChange={(e) => {
												this.handleChangeStickyPositionFromTop(e.target.value)
											}}
											value={this.state.positionFromTop}
											placeholder='Please Enter Position'
										></input>
									</div>
									<div class='mb-2'>
										<div class='row'>
											<label for='text'>Show Sticky</label>
										</div>
										<div class='row'>
											{/* <div>
												<input
													value={'Once'}
													type='radio'
													checked={this.state.showSticky == 'Once'}
													onChange={() => {
														this.handleChangeShowStickyOption('Once')
													}}
													disabled={
														this.props.item.SK != undefined &&
															this.props.item.SK != null &&
															this.props.item.SK == 'm#published' &&
															this.props.item.stickyPost != undefined &&
															this.props.item.stickyPost != null &&
															this.props.item.stickyPost
															? true
															: false
													}
												></input>
												<text for='Once'>Once</text>
											</div> */}
											<div>
												<input
													value={'Unlimited'}
													type='radio'
													checked={this.state.showSticky == 'Unlimited'}
													onChange={() => {
														this.handleChangeShowStickyOption('Unlimited')
													}}
													disabled={
														this.props.item.SK != undefined &&
															this.props.item.SK != null &&
															this.props.item.SK == 'm#published' &&
															this.props.item.stickyPost != undefined &&
															this.props.item.stickyPost != null &&
															this.props.item.stickyPost
															? true
															: false
													}
												></input>
												<text for='Unlimited'>Unlimited</text>
											</div>
											<div>
												<input
													value={'stickyTargetImpressions'}
													type='radio'
													checked={this.state.showSticky == 'stickyNoOfTimes'}
													onChange={() => {
														this.handleChangeShowStickyOption('stickyNoOfTimes')
													}}
													disabled={
														this.props.item.SK != undefined &&
															this.props.item.SK != null &&
															this.props.item.SK == 'm#published' &&
															this.props.item.stickyPost != undefined &&
															this.props.item.stickyPost != null &&
															this.props.item.stickyPost
															? true
															: false
													}
												></input>
												<text for='stickyNoOfTimes'>Number Of Times</text>
											</div>
										</div>
									</div>
									<div>
										{this.state.showSticky == 'stickyNoOfTimes' ? (
											<div class='row mb-2'>
												<label for='text'>Number Of Times </label>
												<input
													id='stickyTargetImpressions'
													type='text'
													onKeyPress={(event) => {
														if (!/[0-9]/.test(event.key)) {
															event.preventDefault()
														}
													}}
													disabled={
														this.props.item.SK != undefined &&
															this.props.item.SK != null &&
															this.props.item.SK == 'm#published' &&
															this.props.item.stickyPost != undefined &&
															this.props.item.stickyPost != null &&
															this.props.item.stickyPost
															? true
															: false
													}
													onChange={(e) => {
														this.handleChangeStickyNoOfTimes(e.target.value)
													}}
													value={this.state.stickyTargetImpressions}
													placeholder='Please Enter Number Of Times'
												></input>
											</div>
										) : null}
									</div>
									<label for='text'>Push this sticky post for</label>
									<input
										id='pushRankUpTo'
										type='text'
										onKeyPress={(event) => {
											if (!/[0-9]/.test(event.key)) {
												event.preventDefault()
											}
										}}
										style={{ width: '50px' }}
										disabled={
											this.props.item.SK != undefined &&
												this.props.item.SK != null &&
												this.props.item.SK == 'm#published' &&
												this.props.item.stickyPost != undefined &&
												this.props.item.stickyPost != null &&
												this.props.item.stickyPost
												? true
												: false
										}
										onChange={(e) => {
											this.handleChangePushRankUpTo(e.target.value)
										}}
										value={this.state.pushRankUpTo}
										placeholder='Please Enter Push Rank UpTo'
									></input>
									<label for='text'>Minutes To this Rank</label>
									<input
										style={{ width: '30px' }}
										id='pushRankTo'
										type='text'
										onKeyPress={(event) => {
											if (!/[0-9]/.test(event.key)) {
												event.preventDefault()
											}
										}}
										disabled={
											this.props.item.SK != undefined &&
												this.props.item.SK != null &&
												this.props.item.SK == 'm#published' &&
												this.props.item.stickyPost != undefined &&
												this.props.item.stickyPost != null &&
												this.props.item.stickyPost
												? true
												: false
										}
										onChange={(e) => {
											this.handleChangePushRankTo(e.target.value)
										}}
										value={this.state.pushRankTo}
										placeholder='Please Enter Push Rank To'
									></input>
								</div>
							) : null}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={() => this.closeStickyModal()}>Cancel</Button>
						{this.state.isDataChanged &&
							this.state.positionFromTop != '' &&
							this.state.positionFromTop ? (
							<Button onClick={() => this.updateContentSticky()}>Ok</Button>
						) : (
							<Button disabled>Ok</Button>
						)}
					</Modal.Footer>
				</Modal>
			</div>
		)
	}
}

export default ContentStickyActions
